import React, { useState } from "react";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import Typography from "@mui/material/Typography";
import { useTranslation } from "react-i18next";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";

export const ReportSection = ({
    id,
    header,
    children,
}: {
    id: string;
    header: string;
    children: JSX.Element | JSX.Element[];
}) => {
    const { t } = useTranslation();
    const [expanded, setExpanded] = useState(true);
    return (
        <Accordion
            variant="elevation"
            expanded={expanded}
            onChange={() => setExpanded(!expanded)}
            sx={{ width: "100%" }}
        >
            <AccordionSummary
                expandIcon={
                    expanded ? (
                        <>
                            <ExpandLessIcon
                                id={`report-section-${id}-expand-less`}
                            />
                            {t("reporting.hideSelection")}
                        </>
                    ) : (
                        <>
                            <ExpandMoreIcon
                                id={`report-section-${id}-expand-more`}
                            />
                            {t("reporting.showSelection")}
                        </>
                    )
                }
                sx={{
                    "& .MuiAccordionSummary-expandIconWrapper": {
                        color: "primary.main",
                        "&.Mui-expanded": {
                            // Don't rotate icon to show text correctly.
                            transform: "rotate(0deg)",
                        },
                    },
                }}
            >
                <Typography marginBottom={0} variant="h3">
                    {header}
                </Typography>
            </AccordionSummary>
            <AccordionDetails>{children}</AccordionDetails>
        </Accordion>
    );
};
